import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    FormControl,
    IconButton,
} from "material-ui";
import { ReduxDispatch } from "ducks/reducers";
import { sendFeedback } from "ducks/feedback";
import { connect } from "react-redux";
import "./index.scss";

interface FeedbackDialogProps {
    open: boolean;
    ToggleShowFeedback: (show: boolean) => void;
}

interface FeedbackDialogState {
    rating: number | undefined;
    hover: number;
    feedback: string;
    showRequiredAlert: boolean;
}

interface FeedbackDispatchProps {
    PostFeedback: (text: string, rating: number) => Promise<void>;
}

type CombinedProps = FeedbackDialogProps & FeedbackDispatchProps;

class FeedbackDialog extends React.Component<
    CombinedProps,
    FeedbackDialogState
> {
    constructor(props: CombinedProps) {
        super(props);
        this.state = {
            rating: undefined,
            hover: 0,
            feedback: "",
            showRequiredAlert: false,
        };
    }

    handleRatingChange = (newRating: number) => {
        this.setState({ rating: newRating });
    };

    handleRatingHover = (hoverRating: number) => {
        this.setState({ hover: hoverRating });
    };

    handleFeedbackChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ feedback: event.target.value });
    };

    handleSubmit = () => {
        const { rating, feedback } = this.state;
        if (rating !== undefined) {
            this.props.PostFeedback(feedback, rating).then((res) => {
                this.setState({ feedback: "", rating: 0 });
            });
            this.props.ToggleShowFeedback(false);
        } else {
            this.setState({ showRequiredAlert: true });
        }
    };

    handleClose = () => {
        this.props.ToggleShowFeedback(false);
    };

    renderRatingOptions = () => {
        let ratingOptions = [];
        for (let i = 0; i <= 10; i++) {
            ratingOptions.push(
                <IconButton
                    key={i}
                    onMouseOver={() => this.handleRatingHover(i)}
                    onMouseLeave={() => this.handleRatingHover(0)}
                    onClick={() => this.handleRatingChange(i)}
                    disableRipple
                    color={
                        i <= this.state.hover
                            ? this.state.rating && i <= this.state.rating
                                ? "primary"
                                : "secondary"
                            : "default"
                    }
                >
                    <div
                        style={{
                            width: "35px",
                            height: "35px",
                            backgroundColor:
                                i === this.state.rating ? "#2196f3" : "#FFFFFF",
                            color:
                                i === this.state.rating ? "#FFFFFF" : "#004170",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "50%",
                            border:
                                i === this.state.rating
                                    ? "1px solid #FFFFFF"
                                    : "1px solid #000",
                            fontSize: "16px",
                            fontWeight: "bold",
                        }}
                    >
                        {i}
                    </div>
                </IconButton>
            );
        }
        return ratingOptions;
    };

    render() {
        const { open } = this.props;
        const { feedback } = this.state;
        const { showRequiredAlert } = this.state;

        return (
            <Dialog
                maxWidth={"sm"}
                open={open}
                onClose={this.handleClose}
                aria-labelledby="feedback-dialog-title"
                style={{ textAlign: "center" }}
            >
                <DialogTitle id="feedback-dialog-title">
                    {"Anna palautetta"}
                </DialogTitle>
                <DialogContent
                    style={{ textAlign: "center", overflow: "hidden" }}
                >
                    <DialogContentText>
                        Kuinka todennäköisesti suosittelisit palvelua ystävälle
                        tai kollegalle?
                    </DialogContentText>
                    <FormControl
                        component="fieldset"
                        style={{ textAlign: "center" }}
                    >
                        <div className="ratingOptionsContainer">
                            <div className="ratingGuideContainer">
                                <span>0 = en suosittelisi lainkaan</span>
                                <span>10 = suosittelisin</span>
                            </div>
                            <div>{this.renderRatingOptions()}</div>
                        </div>
                        <span></span>
                        {showRequiredAlert && (
                            <sub style={{ color: "#D21F3C" }}>
                                Arvostelu puuttuu!
                            </sub>
                        )}
                    </FormControl>
                    <TextField
                        inputProps={{ tabIndex: 0 }}
                        fullWidth
                        multiline
                        spellCheck={false}
                        rows={1}
                        rowsMax={10}
                        value={feedback}
                        onChange={this.handleFeedbackChange}
                        placeholder="Kerro miksi valitsit tämän arvosanan?"
                    />
                </DialogContent>
                <DialogActions style={{ alignItems: "center" }}>
                    <Button onClick={this.handleSubmit} color="secondary">
                        Lähetä
                    </Button>
                    <Button onClick={this.handleClose} color="default">
                        Peru
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapDispatchToProps = (dispatch: ReduxDispatch): FeedbackDispatchProps => {
    return {
        PostFeedback: (text: string, rating: number) =>
            dispatch(sendFeedback(text, rating)),
    };
};

const mapStateToProps = null;

export default connect<
    FeedbackDialogProps,
    FeedbackDispatchProps,
    FeedbackDialogProps
>(
    mapStateToProps,
    mapDispatchToProps
)(FeedbackDialog);



// WEBPACK FOOTER //
// ./src/components/Dialog/FeedbackDialog.tsx